import React from 'react';
const { Icon, Logo } = window;
/* ============================================================
   BOOKER — Tela de login (conta Microsoft / Entra ID)
   onSubmit() abre o popup da Microsoft, valida no backend e só
   autoriza quem está cadastrado na tabela `usuarios`.
   ============================================================ */
var { useState } = React;

function MsLogo({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" aria-hidden="true" style={{ flexShrink: 0 }}>
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}

function Login({ onSubmit, onEmergencia, erro, theme, onToggleTheme }) {
  const [erroLocal, setErroLocal] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [modoEmerg, setModoEmerg] = useState(false);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [carregandoEmerg, setCarregandoEmerg] = useState(false);

  async function entrar() {
    setErroLocal(''); setCarregando(true);
    try {
      await onSubmit(); // redireciona a página para a Microsoft
    } catch (err) {
      setErroLocal(String(err && err.message || '') || 'Não foi possível iniciar o login.');
      setCarregando(false);
    }
  }

  async function entrarEmerg(ev) {
    ev.preventDefault();
    setErroLocal(''); setCarregandoEmerg(true);
    try {
      await onEmergencia(email.trim(), senha);   // sucesso: o App troca a tela
    } catch (err) {
      setErroLocal(String(err && err.message || '') || 'Não foi possível entrar.');
      setCarregandoEmerg(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', gridTemplateColumns: '1.1fr 1fr', background: 'var(--bg)' }}>
      {/* Painel da marca */}
      <div style={{ position: 'relative', overflow: 'hidden', background: 'linear-gradient(150deg, #2F2F31 0%, #3E3E40 60%, #4A3D24 140%)',
        display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '46px 52px', color: '#fff' }}>
        <div style={{ position: 'absolute', width: 520, height: 520, borderRadius: '50%', right: -180, top: -160, background: 'radial-gradient(circle, rgba(255,213,0,.22), transparent 70%)' }} />
        <div style={{ position: 'absolute', width: 360, height: 360, borderRadius: '50%', left: -120, bottom: -120, background: 'radial-gradient(circle, rgba(229,146,48,.20), transparent 70%)' }} />
        <div style={{ position: 'relative' }}><Logo theme="dark" h={60} /></div>

        <div style={{ position: 'relative', maxWidth: 460 }}>
          <h1 style={{ fontSize: 40, fontWeight: 800, lineHeight: 1.08, letterSpacing: '-.025em', margin: 0 }}>Inteligência de<br />contratos em<br /><span style={{ color: 'var(--booker-yellow)' }}>tempo real.</span></h1>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: 'rgba(255,255,255,.78)', marginTop: 18 }}>
            Monitore vencimentos, reajustes e divergências de cobrança a partir dos contratos da sua organização.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 30 }}>
            {[
              { i: 'folder', t: 'Contratos centralizados e versionados' },
              { i: 'sparkles', t: 'Extração inteligente de dados dos contratos' },
              { i: 'bell', t: 'Alertas de renovação e correção monetária' },
            ].map((f, n) => (
              <div key={n} style={{ display: 'flex', alignItems: 'center', gap: 13 }}>
                <span style={{ width: 38, height: 38, borderRadius: 10, background: 'rgba(255,213,0,.16)', color: 'var(--booker-yellow)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name={f.i} size={19} /></span>
                <span style={{ fontSize: 14.5, fontWeight: 600, color: 'rgba(255,255,255,.92)' }}>{f.t}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ position: 'relative', fontSize: 12.5, color: 'rgba(255,255,255,.5)' }}>© 2026 Booker · Inteligência de Negócios</div>
      </div>

      {/* Painel de login */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40, position: 'relative' }}>
        <button onClick={onToggleTheme} title="Alternar tema" style={{ position: 'absolute', top: 24, right: 24, width: 40, height: 40, borderRadius: 'var(--r-sm)', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Icon name={theme === 'light' ? 'moon' : 'sun'} size={19} />
        </button>

        <div style={{ width: '100%', maxWidth: 388, animation: 'fadeUp .4s ease both' }}>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: 'var(--text-strong)', letterSpacing: '-.02em', margin: '0 0 6px' }}>Acessar o sistema</h2>
          <p style={{ fontSize: 14.5, color: 'var(--text-muted)', margin: '0 0 28px' }}>Entre com sua conta corporativa Microsoft.</p>

          <button onClick={entrar} disabled={carregando} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 11,
            padding: '14px 18px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface)', color: 'var(--text-strong)',
            fontSize: 15, fontWeight: 700, boxShadow: 'var(--shadow-sm)', cursor: carregando ? 'default' : 'pointer', opacity: carregando ? 0.8 : 1, transition: 'all .15s' }}
            onMouseEnter={e => { if (!carregando) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = 'var(--shadow)'; } }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; }}>
            {carregando
              ? <><span style={{ width: 18, height: 18, border: '3px solid var(--surface-inset)', borderTopColor: 'var(--booker-orange)', borderRadius: 99, animation: 'spin .8s linear infinite' }} /> Conectando…</>
              : <><MsLogo size={20} /> Entrar com Microsoft</>}
          </button>

          {(erro || erroLocal) && (
            <div style={{ display: 'flex', gap: 9, alignItems: 'center', marginTop: 16, padding: '11px 13px', background: 'var(--danger-bg)', color: 'var(--danger)', borderRadius: 'var(--r-sm)', fontSize: 12.5, fontWeight: 600, lineHeight: 1.45 }}>
              <Icon name="alert" size={16} style={{ flexShrink: 0 }} /> {erro || erroLocal}
            </div>
          )}

          <div style={{ display: 'flex', gap: 10, padding: 14, marginTop: 24, background: 'var(--surface-inset)', borderRadius: 'var(--r)', fontSize: 12.5, color: 'var(--text-muted)', lineHeight: 1.55 }}>
            <Icon name="link" size={17} style={{ color: 'var(--booker-orange)', flexShrink: 0, marginTop: 1 }} />
            <span>Autenticação via <b style={{ color: 'var(--text)' }}>Microsoft Entra ID</b>. No 1º acesso, sua entrada fica <b style={{ color: 'var(--text)' }}>aguardando aprovação</b> de um administrador.</span>
          </div>

          {/* Acesso de emergência (break-glass): e-mail + senha do admin do .env.
              Discreto — só para quando o SSO Microsoft cair ou não houver admin. */}
          <div style={{ marginTop: 18, textAlign: 'center' }}>
            <button type="button" onClick={() => { setModoEmerg(v => !v); setErroLocal(''); }}
              style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 12.5, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <Icon name="settings" size={14} /> Acesso de emergência
              <Icon name={modoEmerg ? 'chevronD' : 'chevronR'} size={13} />
            </button>
          </div>

          {modoEmerg && (
            <form onSubmit={entrarEmerg} style={{ marginTop: 12, padding: 16, background: 'var(--surface-inset)', borderRadius: 'var(--r)', display: 'flex', flexDirection: 'column', gap: 10, animation: 'fadeUp .25s ease both' }}>
              <div style={{ fontSize: 11.5, color: 'var(--text-muted)', lineHeight: 1.5 }}>Use apenas quando o login Microsoft estiver indisponível.</div>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-mail" autoComplete="username"
                style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface)', color: 'var(--text-strong)', fontSize: 14, outline: 'none' }} />
              <input type="password" value={senha} onChange={e => setSenha(e.target.value)} placeholder="Senha" autoComplete="current-password"
                style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface)', color: 'var(--text-strong)', fontSize: 14, outline: 'none' }} />
              <button type="submit" disabled={carregandoEmerg || !email || !senha}
                style={{ width: '100%', padding: '12px', borderRadius: 'var(--r-sm)', border: 'none', background: 'var(--booker-orange)', color: '#fff', fontSize: 14, fontWeight: 700, cursor: (carregandoEmerg || !email || !senha) ? 'default' : 'pointer', opacity: (carregandoEmerg || !email || !senha) ? 0.6 : 1 }}>
                {carregandoEmerg ? 'Entrando…' : 'Entrar'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

Object.assign(window, { Login });
